const searchParamsToObject = (searchString: string) => {
  const searchParams = new URLSearchParams(searchString)

  const searchObject: { [key: string]: string } = {}
  for (const key of searchParams.keys()) {
    searchObject[key] = JSON.parse(searchParams.get(key) as string)
  }
  return searchObject
}

export default searchParamsToObject
